import { appConfig } from '@config';

export default {
  en: {
    'global.actions.press-enter': 'or press ENTER',
    'global.actions.finish': 'Finish',
    'global.actions.continue': 'Continue',
    'global.actions.login': 'Login',
    'global.actions.next': 'Next',
    'global.actions.browse': 'Browse',
    'global.actions.create-account': 'Create Account',
    'global.actions.cancel': 'Cancel',
    'global.actions.confirm': 'Confirm',
    'global.actions.close': 'Close',
    'global.actions.clear': 'Clear',
    'global.actions.apply': 'Apply',
    'global.actions.edit': 'Edit',
    'global.actions.save': 'Save',
    'global.actions.view': 'View',
    'global.actions.send': 'Send',
    'global.actions.processing': 'processing',
    'global.actions.get-started': 'Get Started',
    'global.actions.download': 'Download',
    'global.actions.download-draft-menu-item': 'Draft Return Excel',
    'global.actions.download-filed-return-menu-item': 'Filed Return',
    'global.actions.download-saf-t-menu-item': 'SAF-T',
    'global.actions.download-official-xml-menu-item': 'XML',
    'global.actions.download-excel-menu-item': 'Excel',
    'global.actions.uploaded': 'Uploaded',
    'global.actions.saved': 'Saved...',
    'global.actions.no-results': 'No Results',
    'global.actions.back': 'Back',
    'global.actions.taxCodes.back': 'Tax Codes',
    'global.actions.go-back': 'Go back',
    'global.actions.add': 'Add',
    'global.actions.added': 'Added',
    'global.actions.modify': 'Modify',
    'global.actions.delete': 'Delete',
    'global.actions.overwrite': 'Overwrite',
    'global.actions.deregister': 'De-register',
    'global.actions.open': 'Open',
    'global.actions.restore': 'Restore',
    'global.actions.delete-account': 'Delete account',
    'global.actions.type-to-filter': 'Type to filter',
    'global.actions.draft-options': 'Draft Options',
    'global.actions.filed-return-options': 'Filed Return Options',
    'global.actions.send-electronically': 'Send to HMRC',
    'global.actions.generate': 'Generate',
    'global.actions.send-via-email': 'Send via email',
    'global.actions.box-number': 'Box Number',
    'global.actions.tax-base': 'Tax Base',
    'global.actions.net': 'NET',
    'global.actions.vat': 'VAT',
    'global.actions.vat-p': 'VAT/P',
    'global.actions.vat-r': 'VAT/R',
    'global.actions.vat-zero': 'VAT/0',
    'global.actions.processing-failed': 'Processing failed',
    'global.actions.draft-generated': 'Draft Generated',
    'global.actions.return-submitted': 'Return Submitted',
    'global.actions.draft-submitted': 'Draft Submitted',
    'global.actions.make-adjustments': 'Make Adjustments',
    'global.actions.apply-to-other-registrations': 'Apply to other registrations',
    'global.actions.got-it': 'Okay, got it',
    'global.actions.search': 'Search',
    'global.actions.show.all': 'Show all details',
    'global.actions.hide.all': 'Hide all details',
    'global.actions.load-more': 'Load more',
    'global.actions.skip.to-next': 'Skip to next section',
    'global.actions.restart.section': 'Restart section',
    'global.status.compliance-errors': 'Compliance Errors',
    'global.status.compliance-warnings': 'Compliance Warnings',
    'global.status.get-started': 'Get Started',
    'global.status.inactive': 'Inactive',
    'global.status.due': 'Due',
    'global.status.upload-failed': 'Upload Failed',
    'global.status.processing': 'Processing',
    'global.status.processed': 'Processed',
    'global.status.preparing': 'Preparing',
    'global.status.rejected': 'Rejected',
    'global.status.ready-to-file': 'Ready to File',
    'global.status.ready-to-file-nil': 'Ready to File (nil)',
    'global.status.ready-to-send': 'Ready to Send',
    'global.status.filed': 'Filed',
    'global.status.awaiting-review': 'Awaiting Review',
    'global.status.processing-errors': 'Processing Error',
    'global.actions.show-more': 'Show more',
    'global.header.nav.account-settings': 'Account settings',
    'global.header.nav.sign-out': 'Sign out',
    'global.status.compliance-errors.button': 'Troubleshoot',
    'global.status.get-started.button': 'Get Started',
    'global.status.upload-failed.button': 'Try Again',
    'global.status.processing.button': 'View',
    'global.status.processed.button': 'Generate Draft',
    'global.status.preparing.button': 'Continue',
    'global.status.rejected.button': 'View',
    'global.status.ready-to-file.button': 'Mark as Filed',
    'global.status.ready-to-send.button': 'Send for Review',
    'global.status.payment-due.button': 'Upload',
    'global.status.payment-clearance': 'Payment Clearance',
    'global.status.payment-clearance.button': 'Tax Office Reference',
    'global.status.sent-for-filing.button': 'Filing?',
    'global.status.filed.button': 'View',
    'global.status.awaiting-review.button': 'Review',
    'global.status.processing-errors.button': 'View',
    'global.status.company-review': `${appConfig.company.name} Review`,
    'global.status.company-review.button': 'View',
    'global.actions.confirmation': 'Are you sure you wish to perform this action?',
    'global.actions.final-step.naming': 'Final step: Naming',
    'global.status.client-approval-pending': 'Client Approval Pending',
    'global.status.filing-rejected': 'Filing Rejected',
    'global.status.data-approval': 'Data Rejected',
    'global.password.caps-lock': 'Caps lock on',
    'global.password.requirement-lower': '1 lowercase character',
    'global.password.requirement-upper': '1 uppercase character',
    'global.password.requirement-special': '1 special character',
    'global.password.requirement-length': '8 characters long',
    'global.password.strength.very-weak': 'Very weak',
    'global.password.strength.weak': 'Weak',
    'global.password.strength.okay': 'Okay',
    'global.password.strength.strong': 'Strong',
    'global.password.strength.very-strong': 'Very strong',
    'global.password.strength': 'Password strength',
    'global.password.show-hide': 'Show/Hide Password',
    'global.password.requirements': 'Password requirements',
    'global.feature-disabled.vat-format-message':
      'This feature has been disabled due to this country not using the v-suite template',
    'global.help-window.contact-us': 'Contact us',
    'global.help-window.tour': 'Start a tour',
    'global.help-window.help': 'Visit the help section',
    'global.help-window.hi': 'Hi there,',
    'global.help-window.help-message': 'How can we help you?',
    'global.help-window.feature-disabled': 'This feature is disabled for VatGlobal users.',
    'global.actions.file-processing': 'Your file is being processed, please wait.',
    'global.tours.title': "Let's get you started",
    'global.tours.subtitle': 'Choose a tour below:',
    'global.tours.profile-settings': 'Profile & Settings',
    'global.tours.filing-screens': 'Filing Screens',
    'global.tours.uploading-data': 'Uploading Data',
    'global.tours.tax-codes-explained': 'Tax Codes Explained',
    'global.help-window.contact-window': 'Contact Us',
    'global.help-window.contact-window.name': 'Name',
    'global.help-window.contact-window.country': 'Country',
    'global.help-window.contact-window.email': 'Email address',
    'global.help-window.contact-window.telephone': 'Telephone (optional)',
    'global.help-window.contact-window.contact-you': 'When should we contact you?',
    'global.help-window.contact-window.preferred-contact': 'Preferred contact method',
    'global.help-window.contact-window.telephone-optional': 'Telephone',
    'global.help-window.contact-window.email-optional': 'Email',
    'global.help-window.contact-window.submit': 'Submit',
    'global.status.non-managed-vat': 'Non managed vat number',
    'global.notification.email-success': 'Email sent successfully.',
    'global.notification.email-failure': 'Failed to send email: {error}',
    'global.notification.download-success': 'File download successful.',
    'global.notification.download-failure': 'File download failed: {error}',
    'global.notification.download-failure.static': 'File download failed',
    'global.notification.download-filed-return-failed': 'Your download could not be completed',
    'global.notification.download-filed-return-no-files': 'No matching files could be found',
    'global.notification.upload-success': 'File upload successful.',
    'global.notification.upload-failure': 'File upload failed: {error}',
    'global.actions.upload-filing': 'Upload filing',
    'global.notification.correction-success': 'Correction created',
    'global.notification.correction-failure': 'Failed to create correction. Please try again.',
    'global.notification.default': 'Task completed.',
    'global.notification.submission': 'Electronic filing submitted successfully',
    'global.notification.default-dismiss': 'Dismiss',
    'global.notification.api-error-default': 'An unexpected error occurred, please try again.',
    'global.notification.api-error-conversion-tool-settings':
      'The mappings could not be retrieved. Please try again.',
    'global.notification.api-error-delete-conversion-tool-settings':
      'Failed to delete the mapping.',
    'global.notification.api-error-conversion-tool':
      'An error occurred while initialising the conversion tool.',
    'global.notification.network-error-default':
      'Network error. Please check your connection and try again.',
    'global.notification.resent-otp': 'OTP resent.',
    'global.value.na': 'N/A',
  },
};
